module.exports = __webpack_public_path__ + "img/PB_Slider_Image_Feedback_920x700_L.154f3e85.png";